import React from 'react';
const ContentAssistantRight = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#3F465C';
    delete attribute.stroke;
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5 5H11", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("path", { d: "M5 7.5H8", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("path", { d: "M8.5 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V2C2.5 1.72386 2.72386 1.5 3 1.5H13C13.2761 1.5 13.5 1.72386 13.5 2V7", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("path", { d: "M12 9.69922L14 11.6992M14 11.6992L12 13.6992M14 11.6992L9 11.6992", stroke: stroke, "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default ContentAssistantRight;
